<div class="main-content">
  <div class="container-fluid">
    @if (userDto) {
      <div class="card sq-card">
        <div class="card-header card-header-squirrel">
          @if (userDto.phoneNumber) {
            <h4 >{{userDto.userName}} ({{this.translate.data['PHONENUMBER'] | translate}} allg.: {{userDto.phoneNumber}}) - Mandant: {{assignedTenant}}</h4>
          }
          @if (!userDto.phoneNumber) {
            <h4 >{{userDto.userName}}  - Mandant: {{assignedTenant}}</h4>
          }
          <!-- <h4>{{userDto.userName}}</h4> -->
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-12">
              <div style="height: 100%; min-height: 300px; overflow-y: auto;">
                <!-- <div style="height: calc(100vh - 224px); min-height: 300px; overflow-y: auto;"> -->
                <mat-tab-group dynamicHeight preserveContent animationDuration="0" style="height: 100%; overflow: auto;">
                  <!-- wenn USERINFO wieder aktiviert werden soll: beim "Ändern" wird der USERNAME überschrieben! Fix notwendig! -->
                  <!-- <mat-tab label="{{this.translate.data['USERINFO'] | translate}}">
                  <ng-template matTabContent>
                    <edit-user-profile-info [user]="userDto"></edit-user-profile-info>
                  </ng-template>
                </mat-tab> -->
                @if (showTenantGrpRoles) {
                  <mat-tab label="{{this.translate.data['GRPROLESPERMISSION'] | translate}}">
                    <ng-template matTabContent>
                      <!-- <platform-group-roles-permissions [user]="userDto"></platform-group-roles-permissions> -->
                      <tenant-grouproles [user]="userDto"></tenant-grouproles>
                    </ng-template>
                  </mat-tab>
                }
                @if (showProjects) {
                  <mat-tab label="{{this.translate.data['PROJECTINFOS'] | translate}}">
                    <ng-template matTabContent>
                      <show-user-projects [user]="userDto"></show-user-projects>
                    </ng-template>
                    <!-- <mat-tab label="{{this.translate.data['PROJECTINFOS'] | translate}}" *ngIf="admin" disabled> -->
                    <ng-template matTabContent>
                      <show-user-projects [user]="userDto"></show-user-projects>
                    </ng-template>
                  </mat-tab>
                }
                <!-- <mat-tab label="{{this.translate.data['CHANGEPASSWORD'] | translate}}">
                <ng-template matTabContent>
                  <change-password [user]="userDto"></change-password>
                </ng-template>
              </mat-tab> -->
            </mat-tab-group>
          </div>
        </div>
      </div>
    </div>
  </div>
}
</div>